import React from 'react';
import styles from './About.module.css';

const skills = [
  'Python', 'Django', 'Django Rest Framework', 'Java', 'C#', 'Kafka', 'Docker', 'Kubernetes', 'SQL', 'AWS', 'DataDog',
  'NewRelic', 'JavaScript', 'Jenkins', 'Git', 'Snowflake', 'DBT', 'RabbitMQ'
];

const About = () => {
  return (
    <section id="about" className={styles.about}>
      <h2>About Me</h2>
      <p className={styles.bio}>
        Hi! I am a backend-leaning full-stack software engineer who loves building scalable systems
        and digging into new tech. Lately, I've been especially curious about Data and SRE/DevOps topics
        too — Analytics, Data Warehouses, Docker, Kubernetes, you name it.
      </p>
      <p className={styles.bio}>
        Outside of tech, you'll often find me tinkering with cars, diving into epic fantasy novels,
        sampling a good bourbon or craft beer, or playing a round of Magic: The Gathering with friends.
      </p>
      <h3>My Skills</h3>
      <div className={styles.skills}>
        {skills.map(skill => (
          <span key={skill} className={styles.skill}>{skill}</span>
        ))}
      </div>
    </section>
  );
};

export default About;
